const getTerritoryPromptsPageUrl = (territorySlug: string): string => `/t/${territorySlug}/explore/prompts`;

export default getTerritoryPromptsPageUrl;
